import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function CheckCircle(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 120 120">
      <path d="M80.195 45.993a1.667 1.667 0 012.612 2.05l-.186.236L58.44 73.948a1.67 1.67 0 01-2.093.273l-.236-.179-14.346-12.94a1.667 1.667 0 011.992-2.656l.24.18 13.13 11.847 23.069-24.48zM113.333 60c0 29.455-23.878 53.333-53.333 53.333S6.667 89.455 6.667 60 30.545 6.667 60 6.667A53.335 53.335 0 01113.333 60zM110 60c0-27.614-22.386-50-50-50S10 32.386 10 60s22.386 50 50 50c27.601-.03 49.97-22.399 50-50z"></path>
    </IconSvg>
  );
}
